import React from 'react';

const WidgetPreviewPlantilla = ({ bloques = [], asunto = '' }) => {
  
  // Helper para procesar texto enriquecido con negrillas en React
  const formatearTextoPreview = (texto) => {
    if (!texto) return '';
    const partes = texto.split(/\*\*([\s\S]*?)\*\*/g);
    return partes.map((parte, i) => 
      i % 2 === 1 ? <strong key={i} className="font-bold text-gray-950">{parte}</strong> : parte
    );
  };

  return (
    <div className="bg-white rounded-xl shadow-md border-t-4 border-blue-900 text-gray-700 w-full p-5 max-w-sm mx-auto text-left">
      <div className="space-y-4">
        
        {/* Cabecera del asunto simulada */}
        {asunto && (
          <div className="bg-slate-50 p-2 rounded border border-slate-200 mb-2">
            <span className="text-[10px] font-bold text-slate-400 uppercase block tracking-wider">Asunto:</span>
            <span className="text-xs font-semibold text-slate-800">{asunto}</span>
          </div>
        )}

        {/* Renderizado dinámico de los bloques */}
        {bloques.map((b) => (
          <div key={b.id} className="text-center">
            {b.tipo === 'titulo' && (
              <h2 className="text-base font-black text-blue-900 tracking-tight text-center">{b.value}</h2>
            )}
            
            {b.tipo === 'imagen' && b.value && (
              <img src={b.value} alt="Preview" className="w-full rounded-lg object-cover max-h-36 mx-auto" onError={(e) => e.target.style.display='none'} />
            )}
            
            {b.tipo === 'texto' && (
              <p className="text-gray-600 text-xs whitespace-pre-line leading-relaxed text-center">
                {formatearTextoPreview(b.value)}
              </p>
            )}
            
            {b.tipo === 'boton' && (
              <div className="py-1 text-center">
                <span style={{ backgroundColor: b.color }} className="text-white font-bold text-[11px] px-5 py-2 rounded-md inline-block shadow-sm select-none">
                  {b.value}
                </span>
              </div>
            )}
            
            {b.tipo === 'separador' && (
              <hr className="border-gray-200 my-1" />
            )}
          </div>
        ))}

        {/* Badge indicador de inyección de tracking */}
        <div className="border-t border-gray-100 pt-3 mt-4 text-center">
          <span className="bg-blue-50 text-blue-600 border border-blue-100 px-2 py-0.5 rounded text-[9px] font-mono inline-block">
            🔍 Tracking de apertura activo (píxel backend)
          </span>
        </div>

      </div>
    </div>
  );
};

export default WidgetPreviewPlantilla;